import { FC } from "react";
import { useTranslation } from "react-i18next";

import {
  DropdownBoundTemplate,
  GroupTitleTemplate,
  HtmlInfoTemplate,
} from "@ryde/controls";
import { useHasPermissions } from "@ryde/shared";

export const BulkJourneyAssignForm: FC = () => {
  const { t } = useTranslation();

  const { hasPermissions: hasPermissionCreateJourney } = useHasPermissions({
    entity: "journey",
    action: "create",
  });

  return (
    <>
      <GroupTitleTemplate
        name="journeyReplacementTitle"
        labelTranslated={t("ride.formLabel.journeyReplacementTitle")}
      />

      <HtmlInfoTemplate
        name="journeyReplacementDescription"
        labelTranslated={t("ride.formLabel.journeyReplacementDescription")}
        formAttributes={{
          descriptionTranslationKey:
            "ride.formLabel.journeyReplacementDescription",
          customContainerTopMargin: 0,
          leftOffsetLevel: 1,
        }}
      />

      <DropdownBoundTemplate
        name="journeyId"
        labelTranslated={t("ride.formLabel.journeyId")}
        formAttributes={{
          dropItemsDisableAdd: !hasPermissionCreateJourney,
          dropItemsSource: "journey",
          dropDownTemplate: "{{value}} | {{label}}",
        }}
      />
    </>
  );
};
